<template>
    <div class="ix-formbuilder-component-summary-content">

        <!-- Modal -->
        <div class="modal fade" id="uploadModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="uploadModal" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Envoie de documents</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                                <div class="form-group">
                                    <label for="file">Document</label>
                                    <div class="d-block">
                                        <input type="file" v-on:change="onFileChange" id="documentFile" ref="inputFile">
                                    </div>
                                    <span class="ix-text-secondary ix-text-small">Taille fichier maximale : 10 Mo</span>
                                </div>
                                <div class="form-group" v-show="selectedFile.hasOwnProperty('filename')">
                                    <label for="filename">Nom</label>
                                    <input type="text" class="form-control" v-model="selectedFile.filename" id="filename">
                                </div>
                                <div class="form-group"  v-show="selectedFile.hasOwnProperty('color')"> 
                                    <label for="color">Etiquette</label>
                                    <input type="color" class="form-control" v-model="selectedFile.color">
                                </div>
                        </div>
                        <div class="modal-footer">
                            <button class="ix-btn green" v-on:click="submitFile" type="button" v-bind:disabled="!checkForm() || loading">
                                Enregistrer
                                <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
        </div>


        <div class="formbuilder-component boxed padding" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div class="mb-small">
                <label class="formbuilder-component-label"  v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
            </div>

            <span style="cursor:pointer; font-weight:bold;"  @click="startFileModal()" v-if="displayMode == 'fillable'"><i class="fas fa-plus"></i> Ajouter un document</span>

            <div class="col-sm-12"  v-if="displayMode == 'fillable'">
                <div class="list-upload-files" v-if="currentField.files && currentField.files.length">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Extension</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(uploadFile,index) in currentField.files" :key="index">
                            <td>
                                <a href="#" style="display: flex; align-items: center,">
                                    <span id="cercle" v-bind:style="{'background' : uploadFile.color }"></span> {{ uploadFile.filename }}
                                </a>
                            </td>
                            <td>
                                {{ uploadFile.extension }}
                            </td>
                            <td>
                                <div class="upload-button-actions" style="display: flex; align-items: center;">
                                    <a class="btn btn-primary" :href="uploadFile.document_path"><i class="fas fa-download"></i></a>
                                    <button class="btn btn-danger ml-2" type="button" @click="removeFile(uploadFile,index)"><i class="fas fa-trash"></i></button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            
            <div class="formbuilder-doc-preview" style="display: flex; overflow:scroll" v-if="currentField.files && currentField.files.length">
                <div class="formbuilder-document" v-for="(file,index) in currentField.files" :key="index">
                    <template  v-if="['jpg', 'png', 'jpeg'].includes(file.extension.toLowerCase())">
                        <img :src="file.document_path"/>
                        <p class="formbuilder-document-name">{{ file.filename.substring(0,15) }}</p>
                    </template>
                </div>
            </div>

            <div v-if="getUnpreviewableFiles(currentField.files).length > 0">
                Autres documents
                <ul>
                    <li v-for="(file,index) in getUnpreviewableFiles(currentField.files)" :key="index">
                        <a :href="file.document_path" target="_blank">{{ file.filename.substring(0,15) }}</a>
                    </li>
                </ul>
            </div>

            <div class="alert alert-success mt-2" v-if="message.length">
                {{ this.message }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetForm">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <span v-if="currentField.files && currentField.files.length == 0">Il n'y a pas de documents disponibles</span><br>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Envoi de documents">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-file-upload"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
            </div>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import axios from 'axios'

    export default {
        name: "DocumentComponent",
        props: ['currentField','showIcon','displayMode'],
        data() {
            return {
                message: "",
                getAction: '/api/downloadFile',
                deleteAction: '/api/destroyFile',
                loading: false,
                selectedFile: [],
            }
        },
        mounted() {
            this.currentField.files = this.currentField.files ? this.currentField.files : [];
        },
        methods : {
            startFileModal(){
                $('#uploadModal').modal()
            },
            resetForm(){
                this.message = '';
                this.successUpload = null;
            },
            checkForm(){
                if (this.selectedFile) {
                   return this.selectedFile.file && this.selectedFile.filename
                }
                return false
            },
            onFileChange(e){
                 this.selectedFile = {
                    id: null,
                    filename: null,
                    file: null,
                    color : '#ffffff', 
                    files: []
                }
                var files = e.target.files
                if (!files.length)
                    return;

                this.selectedFile.file = files[0];
                 if (this.selectedFile.filename == "" || this.selectedFile.filename  == null) {
                    this.selectedFile.filename = files[0].name.split('.')[0]
                }   
            },
            submitFile(){
                this.loading = true;
                var data = new FormData()
                data.append('name', this.selectedFile.filename)
                data.append('file', this.selectedFile.file)
                data.append('color', this.selectedFile.color)

                fetch( '/api/upload', {
                     ...{
                        method : "POST"
                    },
                    ...this.getHttpJsonRequestHeaders(true),
                    ...{
                        body : data
                    }
                }).then((response) => {
                    this.loading = false;
                    if(response.ok) {
                        response.json().then(data => {
                            let upload = [{
                                filename : data.name,
                                color : this.selectedFile.color,
                                path : data.path,
                                document_path : data.document_path,
                                extension : data.extension,
                                user_id : data.user_id,
                                id : data.id
                            }]
                            this.currentField.files.push(...upload);
                            this.selectedFile = {}
                            this.$refs.inputFile.value = null
                            $('#uploadModal').modal('hide')
                        })
                    }
                }).catch((error) => {
                    this.loading = false;
                })
            },
            removeFile(file , index){
                this.loading = true;
                 this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "Le fichier sera définitivement supprimé",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        fetch('/api/destroyFile?file_id='+file.id, {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders(),
                        }).then(async (response) => {
                            if(response.ok){
                                this.currentField.files.splice(index , 1);
                                this.message = "Fichier supprimé"
                            }

                            this.loading = false

                        }).catch(error => {
                            this.loading = false
                            console.log(error);
                        })
                    }
                });
            },
            getUnpreviewableFiles(files){
                return files.filter(file => {
                    return !['jpg', 'png', 'jpeg'].includes(file.extension.toLowerCase());
                })
            }
        },

    }
</script>

<style scoped>
.btn-upload {
    width: 100%;
    height: 150px;
    text-align: center;
    font-weight: 600;
    background: #343a40;
    color: white;
    cursor: pointer;
    padding: 10px;
    font-size: 20px;
    border: 1px solid #343a40;
    border-radius: 10px;
    line-height: 6em;
}
.btn-upload-files {
    width: 100%;
    text-align: center;
    color: white;
    background-color: #0f6674;
    border: 1px solid #0f6674;
    font-size: 16px;
    border-radius: 5px;
    padding: 5px;
}
.td-image-thumb {
    max-width: 4em;
    max-height: 4em;
}
.btn-delete-file {
    color: darkred;
    font-weight: 600;
    font-size: 14px;
    border: 0px;
    background: white;
}

.form-input-files {
    display: flex;
}
.draggable-icon {
    align-self: center;
    padding: 10px;
}
.draggable-content {
    align-self: center;
    font-weight: bold;
    width: 100%;
}

#cercle {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    border: 1px solid black;
    display: inline-block;
    margin-right: 5px;
}
</style>
